'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reslickOn = exports.sliderIsSlicked = exports.initSlider = exports.getSlider = exports.slickFilter = exports.sliders = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

require('slick');

var _Helpers = require('scripts/components/Helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var testimonialSliderOptions = {
  rows: 0,
  dots: false,
  arrows: false,
  mobileFirst: true,
  responsive: [{
    breakpoint: 640,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: 992,
    settings: {
      slidesToShow: 3
    }
  }]
};

var cartUpsellSliderOptions = {
  rows: 0,
  dots: true,
  arrows: false,
  mobileFirst: true,
  responsive: [{
    breakpoint: 991,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }]
};

var homepageBestSellersSlider = {
  rows: 0,
  dots: true,
  dotsClass: 'slick-dots slick-dots--big-blue',
  arrows: false,
  mobileFirst: true,
  responsive: [{
    breakpoint: 650,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 991,
    settings: {
      slidesToShow: 4
    }
  }]
};

var homepageReviewsSlider = {
  dots: true,
  dotsClass: 'slick-dots slick-dots--big-blue',
  arrows: true,
  prevArrow: $('.js-slick-reviews-prev'),
  nextArrow: $('.js-slick-reviews-next'),
  centerMode: false,
  mobileFirst: true,
  variableWidth: true,
  responsive: [{
    breakpoint: 991,
    settings: {
      centerMode: false,
      dots: false
    }
  }]
};

var homepageInvest = {
  dots: true,
  dotsClass: 'slick-dots slick-dots--big-blue',
  arrows: true,
  prevArrow: $('.js-slick-invest-prev'),
  nextArrow: $('.js-slick-invest-next'),
  mobileFirst: true,
  responsive: [{
    breakpoint: 992,
    settings: 'unslick'
  }]
};

var instagramSliderOptions = {
  variableWidth: true,
  arrows: false,
  mobileFirst: true,
  responsive: [{
    breakpoint: 992,
    settings: {
      arrows: true,
      prevArrow: $('.js-instagram-slick-prev'),
      nextArrow: $('.js-instagram-slick-next'),
      centerMode: true,
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }]
};

var shopBySliderOptions = {
  rows: 0,
  slidesToShow: 1,
  dots: false,
  arrows: false,
  mobileFirst: true,
  responsive: [{
    breakpoint: 639,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: 991,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: 1199,
    settings: {
      slidesToShow: 4
    }
  }]
};

var crossSellSliderOptions = {
  rows: 0,
  slidesToShow: 1,
  dots: true,
  arrows: false,
  mobileFirst: true,
  infinite: false,
  responsive: [{
    breakpoint: 699,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: 991,
    settings: 'unslick'
  }]
};

var ingredientsSliderOptions = {
  rows: 0,
  dots: true,
  arrows: true,
  dotsClass: 'slick-dots--image',
  customPaging: function customPaging(slider, i) {
    var thumb = $(slider.$slides[i]).data('thumb');
    var type = $(slider.$slides[i]).data('thumb-type');
    var alt = $(slider.$slides[i]).data('thumb-alt');
    return '<button type="button" tole="tab" aria-label="' + i + ' of ' + slider.$slides.length + '" tabIndex="0" data-type="' + type + '"><picture><img src="' + thumb + '" alt="' + alt + '" /></picture></button>';
  },
  prevArrow: '<button class="slick-circle-arrow slick-circle-arrow--prev text-primary" type="button" aria-label="Go to previous slide"><svg width="15px" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg></button>',
  nextArrow: '<button class="slick-circle-arrow slick-circle-arrow--next text-primary" type="button" aria-label="Go to next slide"><svg width="15px" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg></button>'
};

var propValuesSliderOptions = {
  rows: 0,
  slidesToShow: 2,
  slidesToScroll: 2,
  dots: true,
  arrows: true,
  mobileFirst: true,
  infinite: true,
  responsive: [{
    breakpoint: 699,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 991,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4
    }
  }, {
    breakpoint: 1023,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 5
    }
  }]
};

var iconListGenericOptions = {
  rows: 0,
  dots: true,
  dotsClass: 'slick-dots slick-dots--big-blue',
  arrows: true,
  prevArrow: '<button class="slick-arrow slick-arrow--prev"><svg class="icon icon-caret-left" width="7" height="11" viewBox="0 0 7 11" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M-6-5h20v20H-6z"></path><path d="M5.575.133a.46.46 0 01.646 0l.646.64a.452.452 0 010 .642L2.697 5.18l4.17 4.405a.452.452 0 010 .641l-.647.641a.458.458 0 01-.644 0L.133 5.585a.452.452 0 010-.641L5.575.133z" fill="currentColor"></path></g></svg></button>',
  nextArrow: '<button class="slick-arrow slick-arrow--next"><svg class="icon icon-caret-right" width="7" height="11" viewBox="0 0 7 11" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M-6-4h20v20H-6z"></path><path d="M1.425 10.867a.46.46 0 01-.646 0l-.646-.64a.452.452 0 010-.642l4.17-3.765-4.17-4.405a.452.452 0 010-.641L.78.133a.458.458 0 01.644 0l5.443 5.282a.452.452 0 010 .641l-5.442 4.811z" fill="currentColor"></path></g></svg></button>',
  mobileFirst: true,
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 3
    }
  }]
};

var socialGenericOptions = {
  rows: 0,
  arrows: false,
  mobileFirst: true,
  variableWidth: true,
  responsive: [{
    breakpoint: 992,
    settings: {
      arrows: true,
      prevArrow: '<button class="slick-circle-arrow slick-circle-arrow--prev text-primary" type="button" aria-label="Go to previous slide"><svg width="15px" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg></button>',
      nextArrow: '<button class="slick-circle-arrow slick-circle-arrow--next text-primary" type="button" aria-label="Go to next slide"><svg width="15px" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg></button>',
      centerMode: true,
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }]
};

var quotesGenericOptions = {
  rows: 0,
  arrows: true,
  dots: true,
  dotsClass: 'slick-dots slick-dots--big-blue',
  mobileFirst: true,
  prevArrow: '<button class="slick-arrow slick-arrow--prev"><svg class="icon icon-caret-left" width="7" height="11" viewBox="0 0 7 11" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M-6-5h20v20H-6z"></path><path d="M5.575.133a.46.46 0 01.646 0l.646.64a.452.452 0 010 .642L2.697 5.18l4.17 4.405a.452.452 0 010 .641l-.647.641a.458.458 0 01-.644 0L.133 5.585a.452.452 0 010-.641L5.575.133z" fill="currentColor"></path></g></svg></button>',
  nextArrow: '<button class="slick-arrow slick-arrow--next"><svg class="icon icon-caret-right" width="7" height="11" viewBox="0 0 7 11" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M-6-4h20v20H-6z"></path><path d="M1.425 10.867a.46.46 0 01-.646 0l-.646-.64a.452.452 0 010-.642l4.17-3.765-4.17-4.405a.452.452 0 010-.641L.78.133a.458.458 0 01.644 0l5.443 5.282a.452.452 0 010 .641l-5.442 4.811z" fill="currentColor"></path></g></svg></button>'
};

var sliders = exports.sliders = {
  'homepage-reviews': {
    selector: '[data-reviews-slider]',
    options: homepageReviewsSlider
  },
  testimonials: {
    selector: '[testimonials-slider]',
    options: testimonialSliderOptions
  },
  'cart-upsells': {
    selector: '[slider="cart-upsells"]',
    options: cartUpsellSliderOptions
  },
  'homepage-best-sellers': {
    selector: '[slider="best-sellers"]',
    options: homepageBestSellersSlider
  },
  'hompage-invest': {
    selector: '[slider="invest-slider"]',
    options: homepageInvest
  },
  'homepage-instagram': {
    selector: '[data-instagram-slider]',
    options: instagramSliderOptions
  },
  'inline-cart-upsells': {
    selector: '[slider="cart-upsells"]',
    options: Object.assign({}, cartUpsellSliderOptions, {
      responsive: []
    })
  },
  'shop-by': {
    selector: '[data-shop-by-slider]',
    options: shopBySliderOptions
  },
  'cross-sell': {
    selector: '[data-cross-sell-slider]',
    options: crossSellSliderOptions
  },
  'product-ingredients': {
    selector: '[data-ingredients-slider]',
    options: ingredientsSliderOptions
  },
  'prop-values': {
    selector: '[data-product-value-list]',
    options: propValuesSliderOptions
  },
  'icon-list-generic': {
    selector: '[data-icon-list-generic]',
    options: iconListGenericOptions
  },
  'social-generic': {
    selector: '[data-social-generic]',
    options: socialGenericOptions
  },
  'product-slider-generic': {
    selector: '[data-product-slider-generic]',
    options: homepageBestSellersSlider
  },
  'quotes-generic': {
    selector: '[data-quotes-generic]',
    options: quotesGenericOptions
  }
};

var slickFilter = exports.slickFilter = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(sliderName, filter) {
    var $slider;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSlider(sliderName);

          case 2:
            $slider = _context.sent;

            $slider.slick('slickUnfilter');
            $slider.slick('slickFilter', filter);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function slickFilter(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getSlider = exports.getSlider = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(sliderName) {
    var sliderData;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            sliderData = sliders[sliderName];

            if (sliderData.slider) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return initSlider(sliderName);

          case 4:
            _context2.t0 = _context2.sent;
            _context2.next = 8;
            break;

          case 7:
            _context2.t0 = sliderData.slider;

          case 8:
            return _context2.abrupt('return', _context2.t0);

          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function getSlider(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var initSlider = exports.initSlider = function initSlider(sliderName) {
  var extraOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var sliderData = sliders[sliderName];
  var selector = sliderData.selector,
      options = sliderData.options;

  var newOptions = Object.assign({}, options, extraOptions);
  var $slider = $(selector).slick(newOptions);
  sliderData.slider = $slider;
  return sliderData.slider;
};

// Checks if a slider is already setup
var sliderIsSlicked = exports.sliderIsSlicked = function sliderIsSlicked(sliderSelector) {
  var slider = document.querySelector(sliderSelector);
  return slider.classList.contains('slick-initialized');
};

var reslickDebouncer = function reslickDebouncer(sliderName) {
  var shouldReslick = (0, _Helpers.isMobileDevice)();
  if (shouldReslick) {
    var sliderData = sliders[sliderName];
    !sliderIsSlicked(sliderData.selector) && initSlider(sliderName);
  }
};

var reslickOn = exports.reslickOn = function reslickOn(sliderName) {
  var debounceSlider = (0, _Helpers.debounce)(function () {
    reslickDebouncer(sliderName);
  }, 300);
  window.addEventListener('resize', debounceSlider);
};